import React, { Component } from 'react'
import Learning from '../images/learning.svg'
import Author from '../components/Author/Author.jsx'
import Helmet from 'react-helmet'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import SEO from '../components/SEO/Seo.jsx'
import socialCardImage from '../images/ebook-card-image.png'
import Link from 'gatsby-link'
import SocialShare from '../components/SocialShare/SocialShare.jsx'
class componentName extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: ``,
    }
  }
  componentDidMount() {
    document.body.classList.add('ebookbackground')
  }
  componentWillUnmount() {
    document.body.classList.remove('ebookbackground')
  }

  _handleEmailChange = e => {
    this.setState({ email: e.target.value })
  }

  // Post to MC server & handle its response
  _postEmailToMailchimp = (email, attributes) => {
    addToMailchimp(email, attributes)
      .then(result => {
        // Mailchimp always returns a 200 response
        // So we check the result for MC errors & failures
        if (result.result !== `success`) {
          this.setState({
            status: `error`,
            msg: result.msg,
          })
        } else {
          // Email address succesfully subcribed to Mailchimp
          this.setState({
            status: `success`,
            msg: 'Thanks for claiming your pre-release discount',
          })
        }
      })
      .catch(err => {
        // Network failures, timeouts, etc
        this.setState({
          status: `error`,
          msg: err,
        })
      })
  }

  _handleFormSubmit = e => {
    e.preventDefault()
    e.stopPropagation()

    this.setState(
      {
        status: `sending`,
        msg: null,
      },
      // setState callback (subscribe email to MC)
      this._postEmailToMailchimp(this.state.email, {
        pathname: document.location.pathname,
      })
    )
  }
  render() {
    const { data } = this.props
    const { siteMetadata: siteData } = data.site
    const postData = {
      frontmatter: {
        excerpt:
          'Get your copy of HANDS ON GATSBY . Embrace JAMStack with Gatsbyjs and microservices, add authentication, shopping cart and more',
        title:
          'Get your copy of HANDS ON GATSBY . Embrace JAMStack with Gatsbyjs and microservices, add authentication, shopping cart and more',
      },
    }
    return (
      <div className="ebook">
        <div className="back-home">
          <Link to="/" className="a-animation">
            back home
          </Link>
        </div>
        <Helmet>
          <title
          >{`Hands on Gatsbyjs, Learn to supercharge your website, implement the JAMStack with Reactjs and Graphql- ${
            siteData.title
          }`}</title>
          <link rel="canonical" href={`${data.site.siteMetadata.siteUrl}`} />
        </Helmet>
        <SEO
          postPath={data.site.siteMetadata.siteUrl}
          siteMetadata={data.site.siteMetadata}
          ebookDescription="Learn to create amazing websites using the power of Gatsby by building 3 projects with Reactjs and Graphql. Embrace the JAMStack"
          ebookCover={socialCardImage}
          ebookSEO
          ebookTitle="Hands on Gatsbyjs, supercharge your website, implement the JAMStack with Reactjs and Graphql"
        />

        <div className="ebook-logo">
          <div className="title">
            hands on <div>Gatsby</div>
          </div>
          <div className="logo-img">
            <img src={Learning} />
          </div>
        </div>
        <div className="ebook-content">
          <h2>UPDATED to Gatsbyjs v.2</h2>
          <p>
            Learn to create amazing websites using the power of{' '}
            <span>Gatsby</span> by building 3 projects.
          </p>
          <p>
            We will start each project from the ground up, no starter templates,
            this way you will <span>learn</span> the ins and outs of{' '}
            <span>Gatsby</span>.
          </p>
          <p>
            You will learn the fundamentals and best practices for building{' '}
            <span>Gatsby</span> based websites
          </p>
          <p>
            <span>Learn</span> to create e-commerce websites, add authentication
            and more.
          </p>
          <p>
            write <span>modern apps</span> and bring data from anywhere.
          </p>
        </div>
        <div className="subscribe-section">
          <div className="subs">
            drop your email and get a nice<span> 30% discount</span>
            <br />
            pay only <span>$31.50</span> <span className="not-price">$45</span>
          </div>
          <div className="subtitle">*This is a pre-release discount</div>
          <div className="subtitle">
            The ebook will be publish in a couple of days
          </div>
          {this.state.status === `success` ? (
            <div
              className="success-msg"
              dangerouslySetInnerHTML={{ __html: this.state.msg }}
            />
          ) : (
            <div className="form">
              <input
                type="email"
                name="email"
                placeholder="your@email.com"
                onChange={this._handleEmailChange}
              />
              <button onClick={this._handleFormSubmit}>I want my copy</button>
              {this.state.status === `error` && (
                <div
                  className="error-msg"
                  dangerouslySetInnerHTML={{ __html: this.state.msg }}
                />
              )}
            </div>
          )}
        </div>
        <div className="author-section">
          <Author>
            With more tha 20 years as a developer, I've come to work with great
            companies on demanding projects. For the past 5 years I've been
            working with Reactjs helping awesome startups build their apps,
            currently working on 4 Gatsbyjs based projects with different
            complexity levels. With my experience, I will guide you on how to
            get the same results, create from simple websites to complex apps
            integrating microservices, fetching data from multiple sources, work
            with plugins and help you embrace the JAMStack philosophy.
          </Author>
        </div>
        <div className="topics">
          <div className="section-title">
            <span>topics covered</span>
          </div>
          <ul>
            <li>- Installing gatsby-cli</li>
            <li>- Creating the base structure for your blog</li>
            <li>- Configuring sass</li>
            <li>- SEO compatible</li>
            <li>- Adding third party headless cms</li>
            <li>- Fetching data from multiple providers</li>
            <li>- Working with payments</li>
            <li>- Shopping cart & authentication</li>
            <li>- Working with multiple layouts/templates</li>
            <li>- Docker setup</li>
            <li>- Image optimization</li>
            <li>- Leverage Gatsbyjs with webtaskio and Auth0</li>
            <li>- Configure Serverless framework</li>
          </ul>
          <div className="more">.... and much more</div>
          <div>
            <p>Get access to our slack channel</p>
            <p>
              Create production ready applications based on Gatsbyjs and
              JAMStack
            </p>
          </div>
        </div>
        <div className="social-wrapper">
          <div className="share-love">
            Share the love for Gatsby and JAMStack
          </div>
          <SocialShare
            postPath={`${siteData.siteUrl}/hands-on-gatsbyjs`}
            postData={postData}
            hashTags={[
              'gatsbyjs',
              'reactjs',
              'netlify',
              'serverless',
              'webtaskio',
              'auth0',
              'microservices',
              'jamstack',
              'buildwithgatsby',
            ]}
          />
        </div>
      </div>
    )
  }
}

export const pageQuery = graphql`
  query ebookSiteData {
    site {
      siteMetadata {
        title
        author
        siteUrl
      }
    }
  }
`

export default componentName



// WEBPACK FOOTER //
// ./src/templates/ebook.jsx